import Header from './Header-redux';

export default Header;
